export const SEVERITY_LEVELS = ['GREEN', 'YELLOW', 'RED'] as const;

export type SeverityLevel = (typeof SEVERITY_LEVELS)[number];

export const DEFAULT_SEVERITY_LEVEL: SeverityLevel = 'GREEN';

export const SEVERITY_LEVEL_CONFIG: Record<
  SeverityLevel,
  { color: string; label: string; ariaLabel: string }
> = {
  GREEN: { color: '#2e7d32', label: 'Verde', ariaLabel: 'Severidad verde' },
  YELLOW: { color: '#f9a825', label: 'Amarillo', ariaLabel: 'Severidad amarilla' },
  RED: { color: '#c62828', label: 'Rojo', ariaLabel: 'Severidad roja' }
};

export const isSeverityLevel = (value: string): value is SeverityLevel =>
  SEVERITY_LEVELS.includes(value as SeverityLevel);

export const parseSeverityLevel = (value: unknown): SeverityLevel | null => {
  if (value == null || value === '') return null;
  const upper = String(value).toUpperCase();
  return isSeverityLevel(upper) ? upper : null;
};

/** Valor a mostrar en UI: el guardado en API o el default verde. */
export const severityLevelForUi = (value: unknown): SeverityLevel =>
  parseSeverityLevel(value) ?? DEFAULT_SEVERITY_LEVEL;

export interface PhoneCallSeverityLevelUpdateRequest {
  severityLevel: SeverityLevel;
}
